const mobileNav = document.querySelector('.sidenav');
const mobileNavDialog = document.querySelector("header dialog");
const mobileNavBtn = document.querySelector('.m-nav-btn');
const closeMobileNavBtn = document.querySelector('.mobile-nav-close');
const tabbables = mobileNav.querySelectorAll('a, summary, .mobile-nav-close');
tabbables.forEach(link => link.style.display = "none");
let currentWidth = window.innerWidth;
const threshold = 769;
let isOpen = false;

/*
  detect when screen passes 768
 */
window.onresize = () => {
  currentWidth = window.innerWidth;
};

function _viewChanged (nextWidth, currentWidth, threshold) {
  const resizedToMobile = nextWidth < threshold && currentWidth >= threshold;
  const resizedToDesktop = nextWidth >= threshold && currentWidth < threshold;
  return resizedToMobile || resizedToDesktop;
};

/*
  open mobile nav button
 */
mobileNavBtn.addEventListener('click', _openMobileNav);

function _openMobileNav () {
  mobileNav.classList.add("mobile-nav-open");
  mobileNavDialog.showModal();
  tabbables.forEach(link => link.style.display = "block");
  isOpen = true;
  const heading = document.querySelector("#mobile-nav-heading")
  console.log(heading);
  trapFocus(mobileNav, heading);
  heading.focus();
  document.addEventListener("keyup", handleKeyUp);
  return false;
};

/*
  close mobile nav button
 */
closeMobileNavBtn.addEventListener('click', _closeMobileNav);

function _closeMobileNav () {
  mobileNav.classList.remove("mobile-nav-open");
  tabbables.forEach(link => link.style.display = "none");
  mobileNavDialog.close();
  isOpen = false;
  removeTrapFocus();
  document.removeEventListener("keyup", handleKeyUp);
  return false;
};

const trapFocusHandlers = {};

function handleKeyUp(e) {
  console.log(e.key);
  if (e.key == "Escape") {
    _closeMobileNav();  
  }
}

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  console.log(elements);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    console.log(document.activeElement);
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function getFocusableElements(container) {
  return container.querySelectorAll("a:not(.submenu-link), summary, .mobile-nav-close");
}
